import { DatePipe, DecimalPipe, JsonPipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {  MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { FileType } from '../../models/file-details.model';
import { StorageService } from '../../services/storage.service';
import { StorageStateService } from '../../services/storage-state.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ConfirmDialogService } from '../../services/confirm-dialog.service';
import { tap } from 'rxjs';
import { FileDetails } from '../../models/file-details.model';
import { DialogService } from '../../services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'dnv-folder',
  templateUrl: './folder.component.html',
  styleUrl: './folder.component.scss',
  imports: [
    DecimalPipe,
    FormsModule,
    MatTableModule,
    MatIconModule,
    TranslatePipe,
    DatePipe,
    MatIconButton,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    JsonPipe,
  ],
})
export class FolderComponent {
  protected readonly storageService = inject(StorageService);
  protected readonly storageStateService = inject(StorageStateService);
  private readonly dialogService = inject(DialogService);

  protected displayedColumns = [
    'name',
    'size',
    'author',
    'uploadDate',
    'actions',
  ];

  public readonly files = computed(() => {
    const value = this.storageStateService.folderIdResource.value();
    return value ? value.sort((a, b) => a.name.localeCompare(b.name)) : null;
  });

  public readonly error = computed(
    () => !!this.storageStateService.folderIdResource.error(),
  );

  protected readonly FileType = FileType;

  protected readonly MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB

  constructor(private readonly confirmDialogService: ConfirmDialogService) {}

  onDownloadClick(folderId: string, fileId: string, fileName: string) {
    this.dialogService.showInfo(
      'Il download di ' + fileName + ' inizierà a breve...',
    );
    this.storageService.downloadFile(folderId, fileId).subscribe({
      next: (blob: Blob) => {
        this.storageService.triggerBrowserDownload(blob, fileName);
      },
      error: (error) => {
        this.dialogService.showError('Errore durante il download del file');
      },
    });
  }

  protected openDeleteConfirmDialog(file: FileDetails) {
    this.confirmDialogService
      .open({
        title: 'TABLE.CONFIRM_DIALOG.TITLE',
        message: 'TABLE.CONFIRM_DIALOG.BODY',
        messageParam: file.name,
      })
      .pipe(
        tap((result) => {
          if (result) {
            this.storageService.deleteFile(file).subscribe({
              next: () => {
                this.dialogService.showSuccess('File eliminato con successo.');
                this.storageStateService.refreshFiles();
              },
              error: (error) => {
                if (error instanceof HttpErrorResponse && (error.status !== 403)) {
                  this.dialogService.showError(
                    "Errore durante l'eliminazione del file.",
                  )
                }
              }
            });
          }
        }),
      )
      .subscribe();
  }

  protected canBeDownloaded(file: FileDetails): boolean {
    return file.type === FileType.FILE && file.size < this.MAX_FILE_SIZE;
  }

  protected openPreview(file: FileDetails) {
    if (this.canBeDownloaded(file)) {
      this.storageService.openFilePreview(file.parent.id, file.id);
    }
  }
}
